import styled from "styled-components";

export const StyledDeleteButton = styled.button`
  color: rgb(65, 65, 65);
  border: none;
  background-color: transparent;
  font-size: 1rem;
  cursor: pointer;
  &:hover {
    color: crimson
  }
  &:focus {
    outline: none
  }
`;

export const GlobalmenuButton = styled.button`
  color: rgb(65, 65, 65);
  border: none;
  background-color: transparent;
  font-size: 1rem;
  cursor: pointer;
  &:focus {
    outline: none
  }
`;
